import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'



import { 
    displayModalAddReservacion,
    updateInputs,
    editHuesped
} from '../../actions/solicitudhoteles'

class ModalAddReservacion extends Component {

	handleCloseModal = (e) => {
		const modal = document.getElementById('modalAddReservacion')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalAddReservacion .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.displayModalAddReservacion(false, '', ''), 300)
    }
    


	render() {

        const { modalAddReservacion } = this.props

		if (!modalAddReservacion.get('show')) {
			return null
        }

		return(
			<Modal id="modalAddReservacion" show={ true } ZIndex={ 2000 } width={ 820 } >
				<form id="form" onSubmit={ e => { e.preventDefault(); this.props.editHuesped(modalAddReservacion.get('index')) }} noValidate>
					<ModalHeader title={ modalAddReservacion.get('title') } onClose={ (e) => this.handleCloseModal(e) } />
					<ModalButtonStrip>
                        <BoxButton name="check" disabled={ modalAddReservacion.get('btnDisabled') } title="Aceptar" />
					</ModalButtonStrip>
					<ModalBody>
                        <Fragment>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label className="control-label">Proveedor de alojamiento</label>
                                        <input className="form-control input-sm" value={ modalAddReservacion.getIn(['data', 'reservacion', 'proveedor_alojamiento']) ||'' } onChange={ e => this.props.updateInputs(`modalAddReservacion.data.reservacion.proveedor_alojamiento`, e.target.value) } />
                                    </div>
                                </div>
                            </div>

                            <div className="separator"></div>

                            <div className="row">
                                <div className="col-md-12">
                                    <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-trayectos">
                                        <thead>
                                            <tr>
                                                <th className="text-center" colSpan={ 3 }>Alojamiento</th>
                                            </tr>
                                            <tr>
                                                <th>Ciudad</th>
                                                <th>Fecha ingreso</th>
                                                <th>Fecha salida</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                modalAddReservacion.getIn(['data', 'reservacion', 'rutas']).map((t,ti) => {
                                                    return(
                                                        <tr key={`itep[${ti}]`}>

                                                            <td>{t.get('ciudad')}</td>

                                                            <td>
                                                                <input className="form-control input-sm" type="date" value={ t.get('fecha_ingreso') ? t.get('fecha_ingreso') : '' } onChange={ e => this.props.updateInputs(`modalAddReservacion.data.reservacion.rutas.${ti}.fecha_ingreso`, e.target.value) }/>
                                                            </td>

                                                            <td>
                                                                <input className="form-control input-sm" type="date" value={ t.get('fecha_salida') ? t.get('fecha_salida') : '' } onChange={ e => this.props.updateInputs(`modalAddReservacion.data.reservacion.rutas.${ti}.fecha_salida`, e.target.value ) }/>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>                                                
                                    </table>
                                </div>                            
                            </div>

                            <div className="separator"></div>

                            <div className="row">

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">Número reservacion</label>
                                        <input className="form-control input-sm" value={ modalAddReservacion.getIn(['data', 'reservacion', 'numero_reservacion']) || '' } onChange={ (e) => this.props.updateInputs(`modalAddReservacion.data.reservacion.numero_reservacion`, e.target.value) } />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">
                                            Reservacion
                                        </label>
                                        <label className={`form-control input-sm label-upload-file label-upload-file-enabled`} onClick={ () => this.props.displayModalAddFile(true, 'Adjuntar archivo', 'create')} >
                                            <i className="fa fa-upload"></i> { modalAddReservacion.getIn(['data','reservacion','adjunto']) ? modalAddReservacion.getIn(['data','reservacion','adjunto', 'file']).name : ' Seleccione un archivo...' }
                                        </label>
                                    </div>
                                </div>

                            </div>


                            <div className="row">

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">Fecha de compra</label>
                                        <input className="form-control input-sm" type="date" value={ modalAddReservacion.getIn(['data', 'reservacion', 'fecha_compra']) || '' } onChange={ (e) => this.props.updateInputs(`modalAddReservacion.data.reservacion.fecha_compra`, e.target.value) } />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">Valor</label>
                                        <input className="form-control input-sm" value={ modalAddReservacion.getIn(['data', 'reservacion', 'valor_pagado']) || '' } onChange={ (e) => this.props.updateInputs(`modalAddReservacion.data.reservacion.valor_pagado`, e.target.value) } />
                                    </div>
                                </div>                            
                            
                            </div>
                            
                        </Fragment>
					</ModalBody >
					<ModalFooter >
					</ModalFooter>
				</form>
			</Modal>
		)
	}
}

const mapStateToProps = (state) => {
	return {
        modalAddReservacion: state.solicitudhoteles.get('modalAddReservacion'),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
        displayModalAddReservacion: (show, title, mode) => dispatch(displayModalAddReservacion(show, title, mode)), 
        updateInputs: (path, value) => dispatch(updateInputs(path, value)), 
        editHuesped: (index) => dispatch(editHuesped(index)), 
	}
}




export default connect(mapStateToProps, mapDispatchToProps)(ModalAddReservacion)



// WEBPACK FOOTER //
// ./src/components/SolicitudHoteles/ModalAddReservacion.jsx